import React from "react"

import loadingGif from "../assets/loading.gif"

type LoadingOverlayProps = {
  open?: boolean
}

export default function LoadingOverlay({ open = true }: LoadingOverlayProps) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 w-full h-full flex items-center justify-center bg-black/40 transition-all animate-fadeIn">
      <div
        className="flex items-center justify-center"
        style={{ width: "60%", height: "120px", overflow: "hidden" }}
      >
        <img
          src={loadingGif}
          alt="Carregando..."
          className="w-60"
          style={{ objectFit: "cover" }}
        />
      </div>
    </div>
  )
}
